// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".short .Entry[data-v-23425229]{height:100%}@media screen and (min-width:300px) and (max-width:400px){.short .Entry h1[data-v-23425229]{font-size:var(--pw-font-size-large);line-height:var(--pw-line-height-large)}}.short .Entry .entry-title[data-v-23425229]{margin-right:50px}.short .Entry .cta-button[data-v-23425229]{align-self:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
